import { Separator } from 'components/ui/separator';

export const FormsSeparator = () => (
  <Separator className="my-2 bg-base-border ml-2 w-[290px]" />
);
